import { Command } from './Commands';

export class ChangeValue extends Command {
  type: string = 'ChangeValue';
  constructor(public id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
